import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import RightSidebar from './components/RightSidebar';
import Player from './components/Player';
import MobileNav from './components/MobileNav';

// Pages
import Dashboard from './pages/Dashboard';
import Builder from './pages/Builder';
import Rooms from './pages/Rooms';
import Settings from './pages/Settings';
import Demo from './pages/Demo';

export default function App() {
  return (
    <Router>
      <div className="flex h-screen w-full bg-vinyl-900 overflow-hidden font-sans text-gray-200">
        <Sidebar />
        
        <main className="flex-1 flex flex-col min-w-0 relative">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/builder" element={<Builder />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>

        <RightSidebar />
        
        <div className="fixed bottom-0 left-0 right-0 z-50">
          <Player />
        </div>
        
        <MobileNav />
      </div>
    </Router>
  );
}